<div class="login__page">
  <div class="main--wrapper">
    <!-- Start Header Section -->
    <header>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="auth-section--logo">
              <a role="button" [href]="commonService.landingUrl">
                <img
                  [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
                  onerror="this.src='assets/images/logo.png';" class="cursor-pointer" alt="Logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- End Header Section -->

    <!-- Start Login Box Section -->
    <div class="container">
      <form #loginForm="ngForm" id="loginForm">

        <div class="auth-box--wrapper position-relative" *ngIf="!isForceChangePassword">
          <div class="blueish-bg hide-background">
            <div class="shade upper"></div>
            <div class="shade lower"></div>
          </div>
          <div class="box-wrapper">
            <h3 class="auth-box--title">Welcome back!</h3>
            <div class="auth-box-form--wrapper">
              <!-- Email -->
              <div class="form-group"
                [ngClass]="{'error-block' : ((!USER_EMAIL.valid && !USER_EMAIL.untouched) || loginForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)}">
                <label class="font-size-20 mb-15">Enter Your Email</label>
                <input type="text" [(ngModel)]="email" placeholder="hello@mail.com"
                  class="input input__large input__blue" name="USER_EMAIL" id="inputEmail" required
                  (ngModelChange)="removeErrorMsg()"
                  [ngClass]="{'error-input' : ((!USER_EMAIL.valid && !USER_EMAIL.untouched) || loginForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)}"
                  [pattern]="commonService.emailPattern" id="USER_EMAIL" #USER_EMAIL="ngModel"
                  autocomplete="new-password">
                <!-- ^[_aA-zZ0-9\-\_\+]+(\.[_aA-zZ0-9\-\_\+]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$ -->
                <!-- pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$" -->
                <ng-container
                  *ngIf="((!USER_EMAIL.valid && !USER_EMAIL.untouched) || loginForm?.submitted) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)">
                  <div *ngIf="USER_EMAIL.errors?.required" class="error-text">Email is required</div>
                  <div *ngIf="!USER_EMAIL.errors?.required && USER_EMAIL.errors?.pattern" class="error-text">The email
                    you entered isn’t correct. Please check your email.</div>
                </ng-container>
                <ng-container *ngIf="error">
                  <div class="error-text">{{error}}</div>
                </ng-container>
              </div>

              <!-- Password -->
              <div class="form-group"
                [ngClass]="{'error-block' : ((!USER_PASSWORD.valid && !USER_PASSWORD.untouched) || loginForm?.submitted) && (USER_PASSWORD.errors?.required || USER_PASSWORD.errors?.minlength)}">
                <label class="font-size-20 mb-15">Enter Your Password</label>
                <input type="password" [(ngModel)]="password" id="inputPassword" name="USER_PASSWORD"
                  [ngClass]="{'error-input' : ((!USER_PASSWORD.valid && !USER_PASSWORD.untouched) || loginForm?.submitted) && (USER_PASSWORD.errors?.required || USER_PASSWORD.errors?.minlength)}"
                  placeholder="Enter password" class="input input__large input__blue" autocomplete="new-password"
                  required minlength="8" maxlength="50" #USER_PASSWORD="ngModel">

                <ng-container
                  *ngIf="((!USER_PASSWORD.valid && !USER_PASSWORD.untouched) || loginForm?.submitted) && (USER_PASSWORD.errors?.required || USER_PASSWORD.errors?.minlength)">
                  <div *ngIf="USER_PASSWORD.errors?.required" class="error-text">Password is required</div>
                  <div *ngIf="!USER_PASSWORD.errors?.required && USER_PASSWORD.errors?.minlength" class="error-text">
                    Password is wrong.</div>
                </ng-container>

              </div>

              <ng-container *ngIf="captchaVisible">
                <re-captcha (resolved)="resolved($event)"></re-captcha>
              </ng-container>

              <div class="mt-3">
                <div class="row mx-0">
                  <button type="button" id="login-submit-btn" (click)="submit();"
                    class="button primary__button col-md-7 col-12 font-size-18">
                    LOG IN
                  </button>
                  <a id="login-forgot-password-link" [routerLink]="['/forgot']"
                    class="button ghost__button large__button color--blue col-md-5 d-flex justify-content-end pr-1 forgot-button"
                    [ngClass]="{'blink-it': forgotBlink}">
                    Forgot Password
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="auth-box--wrapper position-relative" *ngIf="isForceChangePassword">
          <div class="blueish-bg">
            <div class="shade upper"></div>
            <div class="shade lower"></div>
          </div>
          <div class="box-wrapper">
            <h3 class="auth-box--title mb-3">New password</h3>
            <div class="color--basic--black mb-5 font-size-14">You have already registered with the password provided by the system.
              Create a new password to continue using the system.</div>
            <div class="auth-box-form--wrapper">
              <!-- New Password -->
              <div class="form-group"
                [ngClass]="{'error-block': (NEW_PSWD_TXT.errors && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched || NEW_PSWD_TXT.errors?.pattern))}">
                <label class="font-size-20 mb-15">Enter your new password</label>
                <input type="password" [(ngModel)]="new_pswd" placeholder="****************"
                  class="input input__large input__blue"
                  pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$" name="NEW_PSWD_TXT"
                  required minlength="8" maxlength="50"
                  [ngClass]="{'error-input': (NEW_PSWD_TXT.errors && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched || NEW_PSWD_TXT.errors?.pattern))}"
                  id="NEW_PSWD_TXT" #NEW_PSWD_TXT="ngModel" autocomplete="new-password">
                <ng-container
                  *ngIf="NEW_PSWD_TXT.errors && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched || NEW_PSWD_TXT.errors?.pattern)">
                  <div class="error-text">Password must be at least 8 characters with at least 1 number and 1 special
                    character (&#64;, $, !, %, *, #, ?, &)</div>
                </ng-container>
              </div>

              <!-- Confirm Password -->
              <div class="form-group"
                [ngClass]="{'error-block': conf_pswd && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched) && conf_pswd != new_pswd}">
                <label class="font-size-20 mb-15">Confirm your new password</label>
                <input type="password" [(ngModel)]="conf_pswd" id="CONF_PSWD_TXT" name="CONF_PSWD_TXT"
                  placeholder="****************" class="input input__large input__blue" autocomplete="new-password"
                  [ngClass]="{'error-input': conf_pswd && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched) && conf_pswd != new_pswd}"
                  required #CONF_PSWD_TXT="ngModel">
                <ng-container
                  *ngIf="conf_pswd && (NEW_PSWD_TXT.dirty || NEW_PSWD_TXT.touched) && conf_pswd != new_pswd">
                  <div class="error-text">Password did not match!</div>
                </ng-container>
              </div>

              <div class="mt-3">
                <div class="row mx-0">
                  <button type="button" id="login-new-pswd-submit-btn"
                    [disabled]="!loginForm.valid || conf_pswd != new_pswd"
                    (click)="updatePassword()"
                    class="button primary__button large__button col-md-12 font-size-18">
                    CHANGE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>

      <div class="auth-box--footer">
        <div class="row">
          <div class="col-12">
            <span class="auth-box-footer--text">
              I don't have an account -
            </span>
            <a id="login-sign-up-link" [routerLink]="['/signup']"
              class="btn btn-link btn-link-primary color--blue font-weight-bold">
              SIGN UP
            </a>
          </div>
          <div class="col-12 mt-15">
            <span class="auth-box-footer--text">
              If you previously had an account at
            </span>
            <span class="color--blue font-weight-bold">www.internalvaluation.com</span><span>,
            <br/>please </span>
            <a id="login-sign-up-link-2" [routerLink]="['/signup']"
               class="btn btn-link btn-link-primary color--blue font-weight-bold">
              SIGN UP
            </a>
            <span> for a new account.</span>
          </div>
        </div>
      </div>

    </div>
    <!-- End Login Box Section -->

  </div>
</div>
